import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=9eb87f1c"
import script from "./Collections.vue?vue&type=script&defer=true&lang=js"
export * from "./Collections.vue?vue&type=script&defer=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports